import { render, staticRenderFns } from "./specification-table.vue?vue&type=template&id=7ee35ed0&"
import script from "./specification-table.vue?vue&type=script&lang=js&"
export * from "./specification-table.vue?vue&type=script&lang=js&"
import style0 from "./specification-table.vue?vue&type=style&index=0&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports